
const NotificationIcon = () => {
    
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5273 1.50122H15.0273" stroke="#141615"  strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M19.5308 11.5787C19.5747 14.7236 20.2479 16.5773 20.8461 17.6097C20.9152 17.7233 20.9529 17.8533 20.9553 17.9863C20.9578 18.1193 20.9248 18.2506 20.8599 18.3667C20.7949 18.4828 20.7003 18.5796 20.5857 18.6471C20.4711 18.7147 20.3406 18.7506 20.2076 18.7512H5.34753C4.77767 18.7512 4.40028 18.1362 4.68942 17.6452C5.31343 16.5854 6.02848 14.6331 6.02848 11.2512C6.0286 10.2985 6.23032 9.35658 6.6204 8.4874C7.01047 7.61822 7.58007 6.84143 8.29176 6.20808C9.00345 5.57474 9.84111 5.09916 10.7497 4.81263C11.6583 4.52609 12.6172 4.43507 13.5635 4.54556C17.0368 4.93738 19.482 8.08365 19.5308 11.5787Z"
                stroke="#141615"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M15.7783 19.741C15.7783 20.5366 15.4622 21.2997 14.8996 21.8623C14.337 22.4249 13.574 22.741 12.7783 22.741C11.9827 22.741 11.2196 22.4249 10.657 21.8623C10.0944 21.2997 9.77832 20.5366 9.77832 19.741"
                fill="#141615" />
        </svg>
    )
}

export default NotificationIcon;